import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "./../../widgets/LoadingComponent";
import { getData } from "../../api/ApiRest";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { darkBlue } from "../../helper/colors";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const EmisionFacturas = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Emisión de Facturas",
    },
  },
};

function Home() {
  const token = useSelector((state) => state.auth.tokenSesion);//localStorage.getItem("tokenSesion");
  const [loading, setLoading] = useState(false);
  const [companyNoCertificate, setCompanyNoCertificate] = useState([]);
  const [emisionFacturas, setEmisionFacturas] = useState({
    labels: [],
    datasets: [
      {
        label: "Emitidas con Exito",
        data: [],
        backgroundColor: "blue",
      },
      {
        label: "Errores",
        data: [],
        backgroundColor: "red",
      },
    ],
  });

  const [planSinAsociar, setPlanSinAsociar] = useState([]);

  const navigate = useNavigate();

  const getDataDashBoard = async (isMounted) => {
    getData("api/Configuracion/Dashboard/GetData", {}).then(
      (response) => {
        if (!isMounted.current) return; // Si se está desmontando, no hagas nada

        console.log(response);
        if (response.status === true) {
          setCompanyNoCertificate(response.companiasNoCertificate);
          setEmisionFacturas({
            labels: response.meses,
            datasets: [
              {
                label: "Emitidas con Exito",
                data: response.correctos,
                backgroundColor: "blue",
              },
              {
                label: "Errores",
                data: response.error,
                backgroundColor: "red",
              },
            ],
          });

          setPlanSinAsociar(response.planes);
        } else {
          alert(response.msj);
          alert("Algo salió mal en la petición");
        }
        setLoading(false);
      },
      (error) => {
        if (!isMounted.current) return; // Evita alertas si refrescaste
        setLoading(false);
        console.log("Error", error);
        alert("Algo salió mal por favor verifica");
      }
    );
  };

  useEffect(() => {
    const isMounted = { current: true };

    if (localStorage.getItem("AdminTae") !== "true") {
      navigate("/Home/Cliente");
    }

    setLoading(true);
    if (token) {
      getDataDashBoard(isMounted);
    }

    return () => {
      isMounted.current = false; // Cuando el componente se desmonta
    };
  }, [navigate]);

  return (
    <div className="BodyComponent" style={{ overflow: 'auto' }}>
      {<LoadingComponent Loading={loading} canClose={true} />}
      <h1 className="text-center" style={{ color: darkBlue }}>
        BIENVENIDO A TAE-COL
      </h1>

      <div className="row">
        <div className="col-md-6" style={{ maxHeight: "300px" }}>
          <Bar options={EmisionFacturas} data={emisionFacturas} />
        </div>

        <div className="col-md-6">
          <h5 className="text-center text-danger">
            EMPRESAS SIN CERTIFICADO DIGITAL ({companyNoCertificate.length})
          </h5>
          <div
            className="table-responsive"
            style={{ maxHeight: "300px", height: "300px" }}
          >
            <table className="table table-sm table-bordered table-hover">
              <thead>
                <tr className="table-danger">
                  <th>Nit</th>
                  <th>Nombre</th>
                  <th>Fecha Creación</th>
                </tr>
              </thead>
              <tbody>
                {companyNoCertificate.map((item, key) => (
                  <tr
                    key={key}
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => {
                      navigate("/Home/Empresa/Config/" + item.companyId);
                    }}
                  >
                    <td className="text-center">
                      {item.identificationNumber + "-" + item.dv}
                    </td>
                    <td>{item.company}</td>
                    <td className="text-center">
                      {moment(item.fechaCreacion).format(
                        "D-MM-yyyy / hh:mm:ss a"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row" style={{ marginTop: '-20px' }}>
        <h5 className="text-center text-danger">
          EMPRESAS SIN PLAN ({planSinAsociar.length})
        </h5>

        <div
          className="table-responsive"
          style={{ maxHeight: "250px", height: "210px" }}
        >
          <table className="table table-sm table-bordered table-hover">
            <thead>
              <tr className="table-danger">
                <th>Nit</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              {planSinAsociar.map((item, key) => (
                <tr
                  key={key}
                  style={{ fontSize: "12px", cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Home/Empresa/Config/" + item.company_id);
                  }}
                >
                  <td className="text-center">
                    {item.identification_number}
                  </td>
                  <td>{item.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Home;
